import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AcademicLevelType } from "../../../types/AcademicLevelType";

const initialState: AcademicLevelType = {
    id: "",
    description: "",
    code: "",
    status: false,
};

export const academicLevelSlice = createSlice({
    name: "academicLevelForm",
    initialState,
    reducers: {
        setAcademicLevelData: (state, action: PayloadAction<AcademicLevelType>) => {
            return { ...state, ...action.payload };
        },
        resetAcademicLevelData: () => initialState,
    }
});

export const { setAcademicLevelData, resetAcademicLevelData } = academicLevelSlice.actions;
export default academicLevelSlice.reducer;
